import requestActionModule from './requestActionModule'
import metaActionModule from './metaActionModule'
import optimistActionModule from './optimistActionModule'
import entitiesActionModule from './entitiesActionModule'
import searchesActionModule from './searchesActionModule'
import toastActionModule from './toastActionModule'

export const DEFAULT_MODULES = [
  requestActionModule,
  metaActionModule,
  optimistActionModule,
  entitiesActionModule,
  searchesActionModule,
  toastActionModule,
]
